import axios from 'axios'
import config from './config.js'

const api = {
  get(param) {
    //param.api = 'http://shoptest.ap-ec.cn/'+param.api;  //放到测试环境  get方法所有URL没有前缀，在此做的临时方案
    return axios.get(param.api, {}, config);
  },
  all(param) {//异步多线程请求
    return axios.all(param)
  },
  post(param) {
    config.data = param.data;
    return axios.post(param.api, param.data);
  },

  parse(param) {//从一个字符串中解析出json对象
    return JSON.parse(param);
  },
  stringify(param) {
    return JSON.stringify(param);
  }//用于从一个对象解析出字符串
}

axios.interceptors.response.use(
  response => {
    //特定错误码统一处理
    if (typeof response.data == 'string') {
      var data = JSON.parse(response.data)
    } else if (typeof response.data == 'object') {
      var data = response.data
    }
    return response;
  },
);
export default api;



// WEBPACK FOOTER //
// ./src/api/api.js